module.exports = __webpack_public_path__ + "img/now.c5df0d91.png";